import React from 'react';
import { withRouter } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { OnboardingPage } from '../ui';

const EmailPending = () => {
  return (
    <OnboardingPage title="Email confirmation pending">
      <div>
        <Typography sx={{ fontWeight: 600, mb: 1 }}>Your email is not confirmed yet</Typography>
        <Typography>Please check your inbox and follow the link in the message</Typography>
        <Typography color="textSecondary">Double check your spam folder</Typography>
      </div>
    </OnboardingPage>
  );
};

export default withRouter(EmailPending);
